import { IconProps } from "../../utils/global-types/global-types";

const UserCircleAddIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M10.985 1.165A1.997 1.997 0 0 0 7.79 3.53c.1.17.23.325.38.455a1.96 1.96 0 0 0 1.955.41c.46-.145.845-.46 1.085-.865.105-.17.185-.365.23-.565q.06-.225.06-.465c0-.51-.195-.98-.515-1.335m-.74 1.7h-.37v.39c0 .205-.17.375-.375.375a.38.38 0 0 1-.375-.375v-.39h-.37a.38.38 0 0 1-.375-.375c0-.205.17-.375.375-.375h.37V1.76c0-.205.17-.375.375-.375s.375.17.375.375v.355h.37a.374.374 0 1 1 0 .75"
    ></path>
    <path
      fill="currentColor"
      d="M11 6a4.9 4.9 0 0 0-.36-1.86c-.155.11-.33.195-.515.255q-.081.029-.17.05a4.24 4.24 0 0 1-.935 4.54 2.3 2.3 0 0 0-.55-.5c-1.355-.91-3.575-.91-4.94 0-.22.145-.4.315-.55.5A4.24 4.24 0 0 1 1.75 6 4.253 4.253 0 0 1 6 1.75c.545 0 1.07.105 1.55.295.015-.06.03-.115.05-.175q.089-.278.26-.51A4.9 4.9 0 0 0 6 1C3.245 1 1 3.245 1 6c0 1.45.625 2.755 1.615 3.67 0 .005 0 .005-.005.01.05.05.11.09.16.135.03.025.055.05.085.07.09.075.19.145.285.215l.1.07q.143.097.3.18l.11.065q.15.082.315.15.06.031.12.055.165.068.33.12.06.024.12.04.18.051.36.095.051.016.11.025.209.044.425.065.03.001.06.01.255.024.51.025.256-.001.505-.025.03-.001.06-.01.216-.021.425-.065c.035-.005.07-.02.11-.025.12-.03.245-.055.36-.095q.06-.024.12-.04c.11-.04.225-.075.33-.12q.06-.024.12-.055.158-.068.315-.15c.04-.02.075-.045.11-.065.1-.06.2-.115.3-.18.035-.02.065-.045.1-.07q.15-.104.285-.215c.03-.025.055-.05.085-.07q.084-.068.16-.135c0-.005 0-.005-.005-.01A4.97 4.97 0 0 0 11 6"
    ></path>
    <path
      fill="currentColor"
      d="M6 3.465c-1.035 0-1.875.84-1.875 1.875 0 1.015.795 1.84 1.85 1.87h.09a1.87 1.87 0 0 0 1.81-1.87c0-1.035-.84-1.875-1.875-1.875"
    ></path>
  </svg>
);

export default UserCircleAddIcon;
